<template>
  <div id="app" class="main no-bounce">
    <div class="page-header" v-if="tableData && tableData.length">
      <label class="custom-checkbox">
        <input type="checkbox" v-model="selectAll" @change="toggleSelectAll">
        <span class="checkmark"></span>
        全选
      </label>
      <div class="batch-btn" v-if="handleType === 'update'" @click="allHandle({ type: 'batchUpdate' })">
        <span style="display: inline-block;font-size: 20px;font-weight: 300;margin-right: 4px;line-height: 0;margin-top: -1px;">+</span>批量补充
      </div>
    </div>
    <div class="table-container" v-if="tableData && tableData.length">
      <!-- 表格容器 -->
      <div class="table-wrapper" ref="tableWrapper">
        <table>
          <thead>
            <tr>
              <th class="sticky-col-first" style="border-right: none;">
                <!-- <input type="checkbox" v-model="selectAll"  @change="toggleSelectAll" > -->
                序号
              </th>
              <th v-for="(header, index) in tableHeaders" :key="index" style="border-right: none;">{{ header.label }}</th>
              <th class="sticky-col-last">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
              <td class="sticky-col-first">
                <!-- <input type="checkbox" v-model="selectedRows" :value="row.id"> -->
                <label class="custom-checkbox ">
                  <input type="checkbox" v-model="selectedRows" :value="row.id">
                  <span class="checkmark"></span>
                  {{ rowIndex < 9 ? `0${rowIndex + 1}` : rowIndex + 1 }} 
                </label>
              </td>
              <!-- <td v-for="(cell, cellIndex) in row.cells" :key="cellIndex" :class="{ 'sticky-col-last': cellIndex === row.cells.length - 1 }">{{ cell }}</td> -->
              <td v-for="(cell, cellIndex) in row.cells" :key="cellIndex" style="">
                <span v-if="cell.name === 'transportStatus'"
                  :style="{ color: transportStatusOptions[cell.value] ? transportStatusOptions[cell.value].color : '' }">{{
                    transportStatusOptions[cell.value] ? transportStatusOptions[cell.value].label : '' }}</span>
                <span v-else>{{ cell.value }}</span>
              </td>
              <td class="sticky-col-last">
                <span style="color: #FFBD2D;" v-if="handleType === 'check'" @click="allHandle({ type: 'check', row, rowIndex })">查看</span>
                <span style="color: #FFBD2D;" v-if="handleType === 'update'" @click="allHandle({ type: 'aloneUpdate', row })">修改</span>
                <span style="color: #FFBD2D;" v-if="handleType === 'dispatch' && row.transportStatus && ['none', 'wait_dispatch'].includes(row.transportStatus)" @click="allHandle({ type: 'dispatch', row })">调度</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="empty">
      <img src="@/assets/image/mescroll-empty.png" alt="" class="empty-img">
      <div class="empty-text">暂无柜子数据~</div>
    </div>
  </div>
</template>

<script>
import { getImportOrderContainerList, getExportOrderContainerList } from '@/api/dispatchImportAndExport/orderContainerTable/index.js';
import { Toast } from 'vant';

export default {
  name: 'StickyTable',
  data() {
    return {
      tableHeaders: [], // 表头
      tableData: [], // 表格数据
      selectedRows: [], // 选中的行ID
      selectAll: false, // 全选状态
      pageType: '',// 订单类型  进/出口
      handleType: '',// 操作类型  修改/查看/调度
      orderId: '', // 进/出口订单id
      shipCompanyId: '',// 船公司
      queryParams: {
        pageNum: 1,
        pageSize: 999
      },
      containerTypeOptions: { // 柜子类型
        dry: "干货柜",
        freezer: "冷冻柜",
      },
      transportStatusOptions: { // 订单运输状态
        "none": {
          label: "待调度",
          color: "#FFBD2D"
        },
        "wait_dispatch": {
          label: "待调度",
          color: "#FFBD2D"
        },
        "in_transport": {
          label: "已调度",
          color: "#669EE6"
        },
        "complete_transport": {
          label: "已调度",
          color: "#669EE6"
        }
      },
      setBarTitleOptions:{
					'check':'查看货柜信息',
					'dispatch':'调度货柜信息',
					'update':'跟单录入',
				}
    }
  },
  created() {
    this.orderId = this.$route.query && this.$route.query.orderId ? this.$route.query.orderId : '';
    this.pageType = this.$route.query && this.$route.query.pageType ? this.$route.query.pageType : '';
    this.handleType = this.$route.query && this.$route.query.handleType ? this.$route.query.handleType : '';
    this.shipCompanyId = this.$route.query && this.$route.query.shipCompanyId ? this.$route.query.shipCompanyId : '';
    if(this.handleType&&this.setBarTitleOptions[this.handleType] ) document.title = this.setBarTitleOptions[this.handleType]
    this.getContainersListHandle() 
  },
  mounted() {
    this.preventBounce();
  },
  methods: {
    allHandle({ type, row, rowIndex }) {
      if (type === 'batchUpdate') { // 批量修改
        if (!this.selectedRows || this.selectedRows && !this.selectedRows.length) return Toast.fail('请选择需要补充的柜子~')
        // uni.navigateTo({
          window.uni.redirectTo({
						url: `/pages/tabbar/home/importAndExportList/containersEnteringInfo/index?handleType=batchUpdate&pageType=${this.pageType}&orderId=${this.orderId}&orderContainersIdList=${this.selectedRows}&shipCompanyId=${this.shipCompanyId}`
					})
      } else {
        if (!row.id) return Toast.fail('未获取到柜子id，无法查看详情~')
        if (type === 'aloneUpdate') { // 单独修改柜子
          window.uni.redirectTo({
          // window.uni.navigateTo({
            url: `/pages/tabbar/home/importAndExportList/containersEnteringInfo/index?handleType=aloneUpdate&pageType=${this.pageType}&orderContainerId=${row.id}&orderId=${this.orderId}&shipCompanyId=${this.shipCompanyId}`
          })
        } else if (type === 'check') { // 查看柜子详情
          // window.uni.redirectTo({
          window.uni.navigateTo({
            url: `/pages/tabbar/home/importAndExportList/orderContainerInfo/orderContainerDetails/index?containerId=${row.id}&index=${rowIndex + 1}&pageType=${this.pageType}`
          })
        } else if (type === 'dispatch') { // 调度柜子
          // window.uni.navigateTo({
          window.uni.redirectTo({
            url: `/pages/tabbar/home/importAndExportList/dispatchContainerInfo/index?containerId=${row.id}&pageType=${this.pageType}&orderId=${this.orderId}`
          })
        }
      }
    },
    // 获取并处理柜子列表数据
    async getContainersListHandle() {
      try {
        this.selectAll = false;
        this.selectedRows = [];
        let res = null
        if (this.pageType === 'import') {
          this.tableHeaders = [{ label: '货柜柜号', keyName: 'containerNumber' }, { label: '货柜类型', keyName: 'containerType' }, { label: '调度状态', keyName: 'transportStatus' },
          { label: '货物名称', keyName: 'cargoTypeName' }, { label: '货物重量', keyName: 'cargoWeight' }, { label: '预计送达时间', keyName: 'planLadingContainerTime' }]
          res = await getImportOrderContainerList(this.queryParams, { importOrderId: this.orderId })
        }
        else if (this.pageType === 'export') {
          this.tableHeaders = [{ label: '货柜柜号', keyName: 'containerNumber' }, { label: '订仓号', keyName: 'warehouseOrderNumber' }, { label: '货柜类型', keyName: 'containerType' }, { label: '调度状态', keyName: 'transportStatus' },
          { label: '货物名称', keyName: 'cargoTypeName' }, { label: '货物重量', keyName: 'cargoWeight' }, { label: '预计提货时间', keyName: 'planLadingContainerTime' }, { label: '截补料时间', keyName: 'cutOffMakeContainerTime' }]
          res = await getExportOrderContainerList(this.queryParams, { exportOrderId: this.orderId })
        }
        if (res && res.rows && res.rows.length) {
          console.log('~~~~~~柜子数据', JSON.stringify(res.rows));
          let list = []
          res.rows.map(item => {
            let cell = []
            this.tableHeaders.map(h => {
              let obj = {}
              obj.name = h.keyName
              obj.label = h.label
              if (h.keyName == 'containerType') {
                obj.value = item.containerTypeInfo && item.containerTypeInfo.groupType && item.containerTypeInfo.containerName ? `${item.containerTypeInfo.containerName}${this.containerTypeOptions[item.containerTypeInfo.groupType] ? this.containerTypeOptions[item.containerTypeInfo.groupType] : item.containerTypeInfo.groupType}` : ''
              } else if (h.keyName == 'cargoTypeName') {
                obj.value = item.cargoTypeInfo && item.cargoTypeInfo.name ? item.cargoTypeInfo.name : '--'
              } else if (h.keyName === 'cargoWeight') {
                obj.value = item.cargoWeight ? item.cargoWeight + '吨' : '--'
              } else obj.value = item[h.keyName] ? item[h.keyName] : '--'
              cell.push(obj)
            })
            list.push({
              id: item.orderContainerId,
              transportStatus: item.transportStatus ? item.transportStatus : '',
              cells: cell
            })
          })
          this.tableData = list

        }
      } catch (error) {
        console.log('获取柜子列表失败', error);

      }
    },
    preventBounce() {
      // 阻止触摸事件的默认行为（防止回弹）
      document.body.addEventListener('touchmove', (e) => {
        if (e.target.classList.contains('no-bounce')) {
          e.preventDefault();
        }
      }, { passive: false });
    },
    // 全选/取消全选
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedRows = this.tableData.map(row => row.id);
      } else {
        this.selectedRows = [];
      }
    },
  },
  watch: {
    // 监听选中行变化，更新全选状态
    selectedRows(newVal) {
      
      this.selectAll = this.tableData&&this.tableData.length&&newVal.length === this.tableData.length;
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #F8F8F8;
}

.no-bounce {
  overscroll-behavior: none;
  /* 禁用回弹效果 */
  -webkit-overflow-scrolling: touch;
  /* 启用 iOS 平滑滚动 */
}

.table-container {
  width: 100%;
  /* height: 100vh; */
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  overflow: auto;
  position: relative;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
}

/* Chrome/Safari */
.scroll-container::-webkit-scrollbar {
  display: none;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

th,
td {
  padding: 16px 12px;
  border-bottom: 1px solid #C9C2BB;
  border-right: 1px solid #C9C2BB;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  font-weight: 400;
  font-size: 12px;
  color: #3D3833;
}

th {
  background-color: #FFFFFF;
}

/* 固定表头 */
thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  font-weight: bold;
}

/* 固定第一列（复选框列） */
.sticky-col-first {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #F8F8F8;
}

/* 固定最后一列 */
.sticky-col-last {
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: #F8F8F8;
  border-right: none;
}

/* 表头的固定列需要更深层级的z-index */
thead .sticky-col-first,
thead .sticky-col-last {
  z-index: 3;
}

/* 分页样式 */
// .pagination {
//   margin-top: 16px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 16px;
// }

// .pagination button {
//   padding: 6px 12px;
//   background-color: #409eff;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
// }

// .pagination button:disabled {
//   background-color: #c0c4cc;
//   cursor: not-allowed;
// }

.page-header {
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.batch-btn {
  width: 82px;
  height: 24px;
  background: #3D3833;
  border-radius: 20px 20px 20px 20px;
  font-weight: 400;
  font-size: 12px;
  color: #FFBD2D;
  display: flex;
  align-items: center;
  justify-content: center;
}


.empty {

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70%;

  .empty-img {
    width: 140px;
    height: 140px;
    flex-shrink: 0;
  }

  .empty-text {
    font-weight: 400;
    font-size: 14px;
    color: #3D3833;
    text-align: center;
    margin-top: 64px;
  }
}


.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  font-size: 14px;
  color: #3D3833;
}

/* 隐藏原生复选框 */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* 自定义复选框外观 */
.checkmark {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: white;
  transition: all 0.3s;
  overflow: hidden;
}

/* 选中状态样式 */
.custom-checkbox input:checked+.checkmark {
  background: #F1892E;
  /* 选中背景色 */
  border-color: #F1892E;
}

/* 勾选图标（可选） */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 4px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox input:checked+.checkmark:after {
  display: block;
}
</style>